// import { PERMISSIONS, USER_ROLES } from "@/utils/constants";
// import { ability } from "@/plugins/Casl";
// import store from "@/store";
import http from "@/plugins/Axios";

// const USER_HOME_REDIRECT_ADDRESS = {
//   [USER_ROLES.ADMIN]: "dashboard-index",
//   [USER_ROLES.DEPARTMENT]: "division-orders",
//   [USER_ROLES.OMTK]: "omtk-orders",
//   [USER_ROLES.OZL]: "ozl-orders",
// };
export default async ({ router, next }) => {
  // if (ability.can(PERMISSIONS.DASHBOARD)) {
  //   return router.push({ name: "dashboard-index" });
  // }
  const {
    data: { data },
  } = await http.get("/menus/by-user");
  const redirectUrl = data[0].url;
  if (redirectUrl) {
    return router.push(redirectUrl);
  }
  // const redirectRouteName =
  //   USER_HOME_REDIRECT_ADDRESS[store.getters.user.roles];
  // if (redirectRouteName) {
  //   return router.push({ name: redirectRouteName });
  // }
  return next();
};
